// Element中文样式
import zhLocale from 'view-design/dist/locale/zh-CN';
const zh = {
  "CompanyProfile": "企业基本信息",
  "CompanyName": "Company Name",
  "ExhibitorRegistration": "展商报名",
  // 计划投放广告
  "OnlineAd": "线上广告",
  "Livestream": "直播",
  "ShowCatalogue": "会刊",
  "VisitorTicket": "观众入场证",
  "VisitorBag": "观众手提袋",
  "BanneratEntryHall": "广场广告牌",
  "OthersPleaseOpecify": "其他（注明）",
  "WhichAd": "计划投放广告",
  "PleaseTickYourExhibits": "参展展品",
  "SpaceType": "展位类型",
  "Quantity": "面积",
  "YourExhibitionPlan": "请选择展区",
  "SubmitSpaceApplication": "确认以上信息，并提交展位申请",

  "Homepage": "首页",
  "YourProgress": "参展任务进度",
  "SpaceConstruction": "展位搭建",
  "BadgeApplication": "办理证件",
  "ExhibitorManual": "更多参展服务",
  "RawSpaceConstruction": "光地搭建",
  "SYMA": "司马",
  "FacialBoard": "标摊楣板",
  "ExhibitorBadge": "展商胸卡",
  "VisitorBadge": "观众胸卡",
  "VehiclePass": "车证办理",
  "Important": "注意事项",
  "Contact": "联系人",
  "WelcometoBakeryChina2022": "您好，欢迎参展2022第88届中国国际医药原料药/中间体/包装/设备交易会（API China）",
  "Countdown": "距开展还有87天",
  "YourRreparationProgress": "您需要完成的项目",
  "View": "点击查看",
  "tobecompleted": "项未完成",
  "YourAccount": "账户安全",
  "Changeyourphonenumber": "更换绑定手机号",
  "Changeyouremail": "更换绑定邮箱",
  "Changeyourpassword": "修改账户密码",
  "CompanyCentre": "企业中心",

  ...zhLocale
}

export default zh

